import {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
  type ReactNode,
} from 'react';

interface MarinaModulesRefreshValue {
  /** Call after marina_modules change so nav (e.g. parking links) refetches. */
  bump: () => void;
  tick: number;
}

const MarinaModulesRefreshContext = createContext<MarinaModulesRefreshValue | null>(null);

export function MarinaModulesRefreshProvider({ children }: { children: ReactNode }) {
  const [tick, setTick] = useState(0);
  const bump = useCallback(() => setTick((n) => n + 1), []);
  const value = useMemo(() => ({ bump, tick }), [bump, tick]);
  return (
    <MarinaModulesRefreshContext.Provider value={value}>{children}</MarinaModulesRefreshContext.Provider>
  );
}

/**
 * When provider is missing (e.g. tests), tick stays 0 and bump is a no-op.
 * Layout and module pages use the provider from App.
 */
export function useMarinaModulesRefresh(): MarinaModulesRefreshValue {
  const v = useContext(MarinaModulesRefreshContext);
  return useMemo(() => v ?? { bump: () => {}, tick: 0 }, [v]);
}
